import { defaultModelAssertStatusCode, defaultAssertStatusCode, makeCircuitBreakerHash } from '../../../shared/internal/Context/defaultSettings.mjs';
import { cleanPath } from '../../../shared/internal/utils/pathSimplified.mjs';

const TELEMETRY_ENABLED_SETTING_KEY = 'http.browser.telemetry.enabled';
class Context {
    requestedServerName;
    cancellationToken;
    requestConfig;
    config;
    userConfig;
    model;
    _requestHash;
    _pathSimplified;
    constructor(params) {
        this.config = params.config;
        this.requestConfig = params.requestConfig;
        this.userConfig = params.userConfig || {};
        this._requestHash = params.requestHash;
        this.model = params.model;
        this.globalAssertStatusCode = params.assertStatusCode;
        this.requestedServerName = params.requestedServerName;
        this.cancellationToken = params.cancellationToken;
        this._pathSimplified = params.pathSimplified;
    }
    get failureTreshold() {
        const failureTreshold = this.config.get('http.browser.circuitBreaker.failureTreshold') || 0.9;
        return failureTreshold;
    }
    get minimumSamples() {
        const minimumSamples = this.config.get(`http.browser.circuitBreaker.minimumSamples`) || 9;
        return minimumSamples;
    }
    get maximumSamples() {
        const maximumSamples = this.config.get(`http.browser.circuitBreaker.maximumSamples`) || 10;
        return maximumSamples;
    }
    get maxTimeForHalfOpenRequest() {
        const maxTimeForHalfOpenRequest = this.config.get(`http.browser.circuitBreaker.maxTimeForHalfOpenRequest`) || 5000;
        return maxTimeForHalfOpenRequest;
    }
    get openDuration() {
        const openDuration = this.config.get(`http.browser.circuitBreaker.openDuration`) || 5000;
        return openDuration;
    }
    get samplingDuration() {
        const samplingDuration = this.config.get(`http.browser.circuitBreaker.samplingDuration`) || 5000;
        return samplingDuration;
    }
    get timeout() {
        const timeout = this.userConfig.timeout || this.config.get(`http.browser.timeout`) || 10000;
        return timeout;
    }
    get assertStatusCode() {
        if (this.userConfig.assertStatusCode) {
            return this.userConfig.assertStatusCode;
        }
        if (this.model) {
            const forceGlobal = this.config.get('http.browser.assertStatusCode.forceGlobal');
            /**
             * Это необходимо для обратной совместимости, если настройки в RS нет, то в старых мажорах
             * приортет всегда отдавался глобальному ассерту.
             */
            return forceGlobal === null || forceGlobal
                ? this.globalAssertStatusCode || defaultModelAssertStatusCode(this.model.assertStatusCodes)
                : defaultModelAssertStatusCode(this.model.assertStatusCodes);
        }
        return this.globalAssertStatusCode || defaultAssertStatusCode;
    }
    get telemetryEnabled() {
        const { config } = this;
        if (config.has(TELEMETRY_ENABLED_SETTING_KEY)) {
            return config.getStrict(TELEMETRY_ENABLED_SETTING_KEY);
        }
        return config.get('mcsRunEnv') === 'local';
    }
    get requestType() {
        const requestType = this.config.get('http-api.browser.requestType');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore-next он считает, что условие window.fetch лишнее
        if (requestType === 'fetch' && window.fetch && window.AbortController) {
            return 'fetch';
        }
        return 'xhr';
    }
    get pathSimplified() {
        if (!this._pathSimplified) {
            this._pathSimplified =
                this.config.get(`http.browser.pathSimplified.${this.requestedServerName}`) ||
                    cleanPath(this.requestConfig.url.pathname);
        }
        return this._pathSimplified;
    }
    get requestHash() {
        if (!this._requestHash) {
            this._requestHash = makeCircuitBreakerHash(this.requestConfig.method, this.requestedServerName, this.pathSimplified);
        }
        return this._requestHash;
    }
    /** @deprecated В следующем мажоре Content-Type должен устанавливаться всегда, без возможности управления */
    get legacyRequestContentTypeEnabled() {
        return this.config.get(`http.browser.legacyRequestContentTypeEnabled`) ?? true;
    }
}

export { Context };
//# sourceMappingURL=Context.mjs.map
